import React, { Component } from 'react';
import ConditionedComponent from 'components/ConditionedComponent.js';

class GuildOptions extends Component {
    render() {
        if (this.props.guildOptions.length === 0 && !this.props.showPublic ) {
            return (
            <div className="guild-options-container">
              You are not a part of any guilds yet. To create one, go <a href="/guilds">here</a>.
            </div>
            );
        }
        let publicGuild = {
            guildId: 0,
            name: "Public"
        };
        return (
            <div className="guild-options-container">
              Only members of selected guild will have access
              <div className="guild-options">
                <ConditionedComponent condition={this.props.showPublic}>
                  <GuildOption guild={publicGuild} onClick={() => this.props.onSelectGuild(undefined)}
                    isSelected={this.props.selectedGuild === undefined}
                    />
                </ConditionedComponent>
                {this.props.guildOptions.map(
                    guild =>
                        <GuildOption
                              guild={guild}
                              onClick={() => this.props.onSelectGuild(guild)}
                              isSelected={this.isSelected(guild)}
                              />)
                }
              </div>
            </div>
        );
    }

    isSelected(guild) {
        if (this.props.selectedGuild === undefined) {
            return guild.id === 0;
        }

        return this.props.selectedGuild.guildId === guild.guildId;
    }
}

class GuildOption extends Component {
    render() {
        let className = "guild-option";
        if (this.props.isSelected) {
            className += " selected";
        }
        return (
            <div
              onClick={this.props.onClick}
              className={className}>{this.props.guild.name}</div>
        );
    }
}

export default GuildOptions;
